import React from 'react';

import { Flex, FlexItem, FlexBlock} from '@wordpress/components';

const StepTitle = (props) => {
	
	return (
		<Flex className={props.className} style={{height:'60px'}}>
			<FlexBlock/>
			<FlexItem className="step-title">{props.children}</FlexItem>
			<FlexBlock/>
		</Flex>	
	);
};

export default StepTitle;
